module.exports = __webpack_public_path__ + "Typedepot---CentraleSansBook.311d7ce78d828ceaede5.woff";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/Typedepot---CentraleSansBook.woff
// module id = ../../../../../src/assets/fonts/Typedepot---CentraleSansBook.woff
// module chunks = styles